import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5e303c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-list" }
const _hoisted_2 = { class: "list-unstyled" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-content" }

import { ref, Ref, watch } from 'vue'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { NewsItem } from '@/explore/news/NewsItem'
import { useGroupAdminNews } from './GroupAdminNews'
import { useResearchDataNews } from './ResearchDataNews'
import { UploadIcon } from '@zhuowenli/vue-feather-icons'
import mailImg from '@/assets/icons/mail_gray_60.png'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsList',
  setup(__props) {

const groupAdminNews = useGroupAdminNews()
const researchDataNews = useResearchDataNews()

const refreshRef = ref(0)
const newsItemsRef = ref([]) as Ref<NewsItem[]>

watch(refreshRef, async () => {
  const allNews = (await Promise.all([
    groupAdminNews.getNewsAsync(),
    researchDataNews.getNewsAsync()
  ])).flat()

  // CONSIDER: include event precedence

  newsItemsRef.value = _.sortBy(allNews, n => n.timestamp.toMillis()).reverse().slice(0, 5) // most recent first

}, { immediate: true })

function useImg(item: NewsItem) {
  switch (item.type) {
    case 'FamilyGroupInvite': return mailImg
  }
}

function useIcon(item: NewsItem) {
  switch (item.type) {
    case 'FirstSync':
    case 'Sync':
      return UploadIcon
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsItemsRef.value, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id
        }, [
          (useImg(item))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: useImg(item),
                class: _normalizeClass(["news-icon", item.type])
              }, null, 10, _hoisted_3))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(useIcon(item)), {
                key: 1,
                class: _normalizeClass(["news-icon", item.type])
              }, null, 8, ["class"])),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: item.url,
              class: "link-dark news-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.displayText), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("small", null, _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(item.timestamp)), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})